export default {
  smsTextBlasts: [],
  smsTextBlast: {},
  smsBlastUpload: {}
};
